module.exports = __webpack_public_path__ + "img/header_mob.26e7b7e.webp";